/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/**
 * Rebuy Bundle Builder → Theme Cart Drawer Bridge
 *
 * Rebuy manages its own cart state and never fires the theme's 'product:added'
 * event, so the cart drawer doesn't know items were added until a page refresh.
 */

(function () {
  var originalFetch = window.fetch;

  window.fetch = function () {
    var result = originalFetch.apply(this, arguments);
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';

    if (url.includes('/cart/add') || url.includes('cart/add.js')) {
      result.then(function (response) {
        if (response.ok) {
          response.clone().json().then(function (data) {
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: null,
                  quantity: data.quantity || 1,
                  cartItemKey: data.key || null
                }
              })
            );
          });
        }
      });
    }

    return result;
  };
})();
// Hide Rebuy sticky bar when cart drawer opens
document.addEventListener('product:added', function () {
  var sticky = document.querySelector('[class*="rebuy"][class*="sticky"], [class*="rebuy-cart"]');
  if (sticky) sticky.style.display = 'none';
});